var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var CourseIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 55,
    glyphHeight: 64,
    glyphOffsetX: -2,
    glyphOffsetY: -2
  }), React.createElement("path", {
    d: "M23.6521 34.0001H54.9564V29.8262H27.826L23.6521 34.0001Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M40.3479 17.3048H54.9566V13.1309H44.5218L40.3479 17.3048Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M32 25.6524H54.9565V21.4785H36.1739L32 25.6524Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M15.3043 42.3477H32V38.1738H19.4782L15.3043 42.3477Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M32 54.8691H9.04346V59.0431H32V54.8691Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M32 46.5215H9.04346V50.6954H32V46.5215Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M9.04346 38.1738V42.3477H15.3043L11.1304 38.1738H9.04346Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M19.4782 13.1309H11.1304L15.3043 17.3048L19.4782 13.1309Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M44.5218 6.86927L38.2609 0.608398L15.3044 23.5649L6.95655 15.2171L0.695679 21.478L15.3044 36.0867L44.5218 6.86927Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M52.8696 43.5997C52.8696 41.7215 51.4087 40.2606 49.5305 40.2606C48.487 40.2606 47.6522 39.8432 47.0261 39.2171C45.3565 37.7563 43.2696 37.965 42.2261 39.2171C41.6 39.8432 40.7652 40.2606 39.7218 40.2606H39.5131C37.8435 40.2606 36.3826 41.7215 36.3826 43.5997C36.3826 44.6432 35.9652 45.478 35.3392 46.1041C35.1305 46.3128 35.1305 46.3128 35.1305 46.3128C33.8783 47.565 34.087 49.6519 35.3392 50.9041C35.9652 51.5302 36.3826 52.365 36.3826 53.4084V53.6171C36.3826 55.2867 37.8435 56.7476 39.7218 56.7476C40.1392 56.7476 40.5565 56.7476 40.9739 56.9563H40.3478V63.2171L44.5218 59.0432L48.6957 63.2171V56.9563H48.2783C48.6957 56.7476 49.1131 56.7476 49.5305 56.7476H49.7392C51.4087 56.7476 52.8696 55.2867 52.8696 53.4084C52.8696 52.365 53.287 51.5302 53.9131 50.9041C54.1218 50.6954 54.1218 50.6954 54.1218 50.6954C55.3739 49.4432 55.1652 47.3563 53.9131 46.1041C53.287 45.478 52.8696 44.6432 52.8696 43.5997ZM44.5218 52.7824C42.2261 52.7824 40.3478 50.9041 40.3478 48.6084C40.3478 46.3128 42.2261 44.4345 44.5218 44.4345C46.8174 44.4345 48.6957 46.3128 48.6957 48.6084C48.6957 50.9041 46.8174 52.7824 44.5218 52.7824Z",
    fill: "black"
  }));
};
export var CourseIconGlyph = function (props) {
  return React.createElement(CourseIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};